import type {
    ExportName,
    SimilarwebFieldsConfig,
    TableSettingsField,
} from "app/pages/sales-intelligence/sub-modules/management/store/type";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import {
    getAccountsFields,
    preDefinedCreateField,
    preDefinedField,
    preDefinedUpdateField,
    technographicsField,
} from "../../manage-integration/configs/accountsFields";
import { getCompanyAsLeadsFields } from "../../manage-integration/configs/companyAsLeadsFields";
import { getContactsFields } from "../../manage-integration/configs/contactsFields";
import { getLeadsFields } from "../../manage-integration/configs/leadsFields";
import { isSamePredefinedFieldType, getPredefinedFieldBase } from "../../../common-components/export-table/utils";

export const createSettings = (integrationName: Integration, isPredefinedOnCreateUpdateEnabled: boolean) => {
    const filterSettingsBySavedSetting = (similarwebFieldsConfig: SimilarwebFieldsConfig): TableSettingsField[] => {
        return Object.keys(similarwebFieldsConfig)
            .filter((field) => !similarwebFieldsConfig[field]?.isEnrichmentOnly)
            .map((field) => ({
                similarweb: { ...similarwebFieldsConfig[field] },
                selected: false,
            }));
    };
    return {
        getSettingsFilteredBySavedSetting(configName: ExportName): TableSettingsField[] {
            const config = {
                accounts: getAccountsFields(),
                leads: getLeadsFields(),
                companyAsLeads: getCompanyAsLeadsFields(),
                contacts: { ...getContactsFields(integrationName) },
            };

            const predefinedFields = isPredefinedOnCreateUpdateEnabled
                ? { ...preDefinedField, ...preDefinedCreateField, ...preDefinedUpdateField }
                : preDefinedField;

            return filterSettingsBySavedSetting(
                configName === "contacts" && (integrationName === "salesforce" || integrationName === "dynamics")
                    ? { ...predefinedFields, ...config[configName] }
                    : { ...predefinedFields, ...technographicsField, ...config[configName] },
            );
        },
        setupSelectedSwFields(availableSWFields: TableSettingsField[], selectedFields: string[]): TableSettingsField[] {
            return availableSWFields.map((metadata) => {
                const availableFieldName = metadata.similarweb.field;

                const checkSelected = selectedFields.find((field) => {
                    if (getPredefinedFieldBase(field) || getPredefinedFieldBase(availableFieldName)) {
                        return isSamePredefinedFieldType(field, availableFieldName);
                    }

                    return field === availableFieldName;
                });

                if (checkSelected) {
                    return {
                        ...metadata,
                        selected: true,
                    };
                } else {
                    return metadata;
                }
            });
        },
    };
};
